import moment from 'moment';

export const FORMATO_FECHA_DEFECTO = 'YYYY-MM-DD'

/**
 * 
 * @param {string} fecha 
 * @param {string} fechaAComparar 
 */
export const fechaAnterior = (fecha, fechaAComparar) => {
  const fechaDeReferencia = moment(fecha, FORMATO_FECHA_DEFECTO)
  const fechaAComparacion = moment(fechaAComparar, FORMATO_FECHA_DEFECTO);

  return fechaDeReferencia.isBefore(fechaAComparacion)
}